import { React, useState, useRef, useEffect } from "react";

import { Link, useLocation } from "react-router-dom";
import logo_black from '../images/logo_black.png'
import menu from '../images/menu_icon.png'
import close from '../images/close_icon.png'
import list from '../images/list.png'
import legaldropdown from '../images/legal_dropdown.png'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Button from "./Button";



function Navbar() {
    const [dropdown, setDropdown] = useState(false);
    const [mobileNav, setmobileNav] = useState(false);
    const [showAnimation, setShowanimation] = useState(false);


    const { pathname } = useLocation();
    const pathArray = pathname.split("/").filter(Boolean);

    let key;
    if (pathArray.length > 1) {
        key = pathArray[0];
    } else { key = null }

    const [showResidential, setShowResidential] = useState(false);
    const [showPropertyMgmt, setShowPropertyMgmt] = useState(false);

    const navItems = [
        { name: "About", path: "/about" },
        {
            name: "Properties",
            path: "/residential",
            children: [
                { name: "Apartments", path: "/apartments-and-villas-for-sale-in-coimbatore" },
                { name: "Resale", path: "/buy-house-in-coimbatore" },
                { name: "Plots", path: "/plots-for-sale-in-coimbatore" },
            ],
        },
        { name: "Industries", path: "/industries" },
        { name: "Liaison", path: "/liaison" },
        { name: "Registration", path: "/registration" },
        { name: "Digital Survey", path: "/digitalsurvey" },
        {
            name: "Property Management",
            path: "/agri-propertymanagement",
            children: [
                { name: "Property Management", path: "https://www.thepropertyguardian.co", external: true },
                { name: "Agri-Property Management", path: "/agri-propertymanagement" },
            ],
        },
    ];

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, [showAnimation])



    return (
        <>
            <div className="relative z-10">
                <div className="px-16 py-8 bg-white items-center hidden xl:flex flex-row">
                    <div className="w-1/4">
                        <Link to="/home"><img className="w-[175px]" src={logo_black} alt="black_logo" /></Link>
                    </div>

                    <div className="w-3/4 ">
                        <div className="flex flex-row gap-x-3 justify-end items-center font-alibaba text-[14px] uppercase leading-[16px] tracking-[1px] text-font-grey">

                            {/* old Nav */}
                            {/* {navItems.map((item) => (
                                <div key={item.path} className="relative group">
                                    <Link
                                        to={item.path}
                                        className={`
                                    relative px-2
                                    after:content-[''] after:absolute after:left-0 after:-bottom-2
                                    after:h-[2px] after:bg-yellow after:w-full 
                                    after:scale-x-0 after:origin-left after:transition-transform after:duration-300
                                    hover:after:scale-x-100
                                    ${pathname === item.path || item.path.slice(1) === pathArray[0] ? "after:scale-x-100 font-semibold" : ""}
                                    `}
                                    >
                                        {item.name}
                                    </Link>

                                    {item.children && (<div className="absolute top-4 border left-0 mt-2 hidden group-hover:block bg-white text-white rounded-b-md border-grey shadow-xl w-48 bg-white">

                                        <ul className="flex flex-col p-2 gap-y-2 ">
                                            {item.children.map((sub) => (
                                                <li key={sub.path} className="p-2 hover:bg-yellow">
                                                    <Link
                                                        to={sub.path}
                                                        className="font-alibaba text-[14px] uppercase leading-[16px] tracking-[1px] text-font-grey hover:bg-yellow w-full"
                                                    >
                                                        {sub.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    )}
                                </div>
                            ))} */}

                            {navItems.map((item) => {
                                const isActive =
                                    pathname === item.path ||
                                    (item.children && item.children.some((sub) => !sub.external && pathname.startsWith(sub.path)));

                                return (
                                    <div key={item.path} className="relative group">
                                        <Link
                                            to={item.path}
                                            className={`
                                            relative px-2
                                            after:content-[''] after:absolute after:left-0 after:-bottom-2
                                            after:h-[2px] after:bg-yellow after:w-full 
                                            after:scale-x-0 after:origin-left after:transition-transform after:duration-300
                                            hover:after:scale-x-100
                                            ${isActive || item.path.slice(1) === pathArray[0] ? "after:scale-x-100 font-semibold" : ""}
                                        `}
                                        >
                                            {item.name}
                                        </Link>

                                        {/* Dropdown only if children exist */}
                                        {item.children && (
                                            <div className="absolute top-2 left-0 mt-2 hidden group-hover:block bg-white text-white rounded-b-md border-grey shadow-xl w-48 bg-white">
                                                <ul className="flex flex-col p-2 gap-y-2 ">
                                                    {item.children.map((sub) => (
                                                        <li key={sub.path} className="p-2 hover:bg-yellow">
                                                            {sub.external ? (
                                                                <a
                                                                    href={sub.path}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="font-alibaba text-[14px] uppercase leading-[16px] tracking-[1px] text-font-grey hover:bg-yellow w-full"
                                                                >
                                                                    {sub.name}
                                                                </a>
                                                            ) : (
                                                                <Link
                                                                    to={sub.path}
                                                                    className={`font-alibaba text-[14px] uppercase leading-[16px] tracking-[1px] text-font-grey hover:bg-yellow w-full ${pathname === sub.path ? "font-semibold" : ""
                                                                        }`}
                                                                >
                                                                    {sub.name}
                                                                </Link>
                                                            )}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}


                            <Button
                                name={"Enquire Now"}
                                design={"filled"}
                                action={"internal-linking"}
                                pageLink={"/contact"}
                            />
                        </div>

                        {/* <div className="hidden flex flex-row gap-x-9 justify-end items-center font-alibaba text-[13px] uppercase leading-[16px] tracking-[1px] text-font-grey">

                            <Link className="transition-all ease-in-out hover:scale-125 hover:border-b-2 border-yellow hover:pb-1" to="/about"><p>About</p></Link>
                            <Link className="transition-all ease-in-out hover:scale-125 hover:border-b-2 border-yellow hover:pb-1" to="/residential"><p>Residential</p></Link>

                            <Link className="transition-all ease-in-out hover:scale-125 hover:border-b-2 border-yellow hover:pb-1" to="/industries"><p>Industries</p></Link>
                            <Link className="transition-all ease-in-out hover:scale-125 hover:border-b-2 border-yellow hover:pb-1" to="/liaison"><p>Liaison</p></Link>
                            <Link className="transition-all ease-in-out hover:scale-125 hover:border-b-2 border-yellow hover:pb-1" to="/registration"><p>Registration</p></Link>
                            <Link className="transition-all ease-in-out hover:scale-125 hover:border-b-2 border-yellow hover:pb-1" to="/digitalsurvey"><p>Digital Survey</p></Link>
                            <Button
                                name={"Enquire Now"}
                                design={"filled"}
                                action={"internal-linking"}
                                pageLink={"/contact"}
                            />

                        </div> */}
                    </div>


                </div>

                {/*Services - Dropdown */}
                {/* <div className={dropdown === true ? "w-full bg-white px-16 h-[280px] absolute top-36" : "hidden"}>
                    <div className="flex flex-row items-center justify-end">
                        <div ref={service_menu} className="bg-card-grey w-[481px] h-[231px] p-7">
                            <div className="flex flex-row items-center gap-x-2">
                                <img className="w-3 h-3" src={list} alt="arrow-vector" />
                                <Link to ="/liaison"><p className="font-[Lato text-[16px] -tracking-[0.14px] leading-[15px] text-font-brown duration-700 transition hover:scale-110 hover:font-bold "onClick={() => {setDropdown(false)}}>Liasion Services</p></Link>
                            </div>
                            <div className="flex flex-row items-center gap-x-2 mt-7">
                                <img className="w-3 h-3" src={list} alt="arrow-vector" />
                                <Link to ="/legal"><p className="font-[Lato text-[16px] -tracking-[0.14px] leading-[15px] text-font-brown duration-700 transition hover:scale-110 hover:font-bold "onClick={() => {setDropdown(false)}}>Legal Services</p></Link>
                            </div>
                        </div>

                        <div className="bg-white">
                            <img className="w-[431px] h-[231px]" src={legaldropdown} alt="legal_dropdown_image" />
                        </div>
                    </div>
                </div> */}

            </div>






            {/*Mobile NavBar*/}

            <div className="p-6 flex flex-row justify-between items-center  xl:hidden">
                <Link to="/home"><img src={logo_black} className="w-[132px] h-[63px]" alt="black_logo" /></Link>

                <img onClick={() => { setmobileNav(!mobileNav) }} className="w-[28px] h-[20px] mr-1 cursor-pointer " src={menu} alt="menu_icon" />
            </div>

            <div id='mobileNav' className={mobileNav === true ? 'fixed w-[70%] h-full bg-[#363537] font-[lato] text-white uppercase inset-y-0 right-0 z-20 overflow-hidden px-7 z-0' : "hidden"}>
                <img className="w-[20px] h-[20px] absolute right-[40px] top-[50px] cursor-pointer" src={close} alt="close_icon" onClick={() => { setmobileNav(!mobileNav) }} />
                <div className="mt-[100px]">
                    <div className="flex flex-col gap-y-6 z-10">
                        <Link to="/about" onClick={() => { setmobileNav(!mobileNav) }}><p className="font-alibaba text-[16px] uppercase leading-[30px] tracking-[1px] text-white">About</p></Link>
                        <div className="cursor-pointer" onClick={() => { setShowResidential(!showResidential) }}> <p className="font-alibaba text-[16px] uppercase leading-[30px] tracking-[1px] text-white">Properties</p></div>
                        {/* Dropdown Menu */}
                        <div
                            className={` ${showResidential ? "max-h-40 opacity-100 pl-4 flex flex-col gap-y-3 overflow-hidden transition-all duration-300 ease-in-out" : "hidden"
                                }`}
                        >
                            <Link
                                to="/apartments-and-villas-for-sale-in-coimbatore"
                                onClick={() => {setmobileNav(!mobileNav); setShowResidential(!showResidential)}}
                            >
                                <p className="font-alibaba text-[14px] leading-[26px] text-white">Apartments</p>
                            </Link>

                            <Link
                                to="/buy-house-in-coimbatore"
                                onClick={() => {setmobileNav(!mobileNav); setShowResidential(!showResidential)}}
                            >
                                <p className="font-alibaba text-[14px] leading-[26px] text-white">Resale</p>
                            </Link>
                            
                            <Link
                                to="/plots-for-sale-in-coimbatore"
                                onClick={() => {setmobileNav(!mobileNav); setShowResidential(!showResidential)}}
                            >
                                <p className="font-alibaba text-[14px] leading-[26px] text-white">Plots</p>
                            </Link>

                        </div>
                        <Link to="/industries" onClick={() => { setmobileNav(!mobileNav) }}><p className="font-alibaba text-[16px] uppercase leading-[30px] tracking-[1px] text-white">Industries</p></Link>
                        <Link to="/liaison" onClick={() => { setmobileNav(!mobileNav) }}><p className="font-alibaba text-[16px] uppercase leading-[30px] tracking-[1px] text-white">Liaison</p></Link>
                        <Link to="/registration" onClick={() => { setmobileNav(!mobileNav) }}><p className="font-alibaba text-[16px] uppercase leading-[30px] tracking-[1px] text-white">Registration</p></Link>
                        <Link to="/digitalsurvey" onClick={() => { setmobileNav(!mobileNav) }}><p className="font-alibaba text-[16px] uppercase leading-[30px] tracking-[1px] text-white ">Digital Survey</p></Link>
                        <div className="cursor-pointer" onClick={() => { setShowPropertyMgmt(!showPropertyMgmt) }}><p className="font-alibaba text-[16px] uppercase leading-[30px] tracking-[1px] text-white">Property Management</p></div>
                        {/* Property Management Dropdown Menu */}
                        <div
                            className={` ${showPropertyMgmt ? "max-h-40 opacity-100 pl-4 flex flex-col gap-y-3 overflow-hidden transition-all duration-300 ease-in-out" : "hidden"
                                }`}
                        >
                            <a
                                href="https://www.thepropertyguardian.co"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => { setmobileNav(!mobileNav); setShowPropertyMgmt(!showPropertyMgmt) }}
                            >
                                <p className="font-alibaba text-[14px] leading-[26px] text-white">Property Management</p>
                            </a>

                            <Link
                                to="/agri-propertymanagement"
                                onClick={() => { setmobileNav(!mobileNav); setShowPropertyMgmt(!showPropertyMgmt) }}
                            >
                                <p className="font-alibaba text-[14px] leading-[26px] text-white">Agri-Property Management</p>
                            </Link>

                        </div>


                        <Button
                            name={"Enquire Now"}
                            design={"filled"}
                            action={"internal-linking"}
                            pageLink={"/contact"}
                            onClick={() => { setmobileNav(!mobileNav) }}
                        />

                    </div>
                </div>


            </div>

        </>
    )
}






export default Navbar;